import React from 'react';
import { SkeletonChartBar } from '../../../chart/bar/skeleton-chart-bar';

export const SkeletonDashboardProfitChart: React.FC = () => {
    return <SkeletonChartBar />;
};
